const Kaeriten = {
    elemName: '返り点',
    type: 'inline',
    doc: '漢文の送り仮名をマークアップします。',
    example: '｛＿レ｝',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '＿{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Kaeriten {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<metamark function="kaeriten">レ</metamark>`,
    docxTemplate: `
			<w:r>
        		<w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                    <w:vertAlign w:val="subscript"/>
                </w:rPr>
                <w:t>{{{$$1}}}</w:t>
            </w:r>
	`,
    latexTemplate: '\\kaeriten{ {{{$1}}} }'
};
export default Kaeriten;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS2Flcml0ZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9LYWVyaXRlbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLFFBQVEsR0FBbUI7SUFDaEMsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxvQkFBb0I7SUFDekIsT0FBTyxFQUFFLE1BQU07SUFDZixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsU0FBUztJQUN2QixZQUFZLEVBQUUsbUVBQW1FO0lBQ2pGLFdBQVcsRUFBRSw0Q0FBNEM7SUFDekQsWUFBWSxFQUFFOzs7Ozs7OztFQVFiO0lBQ0QsYUFBYSxFQUFFLHdCQUF3QjtDQUV2QyxDQUFDO0FBRUYsZUFBZSxRQUFRLENBQUMifQ==